import { useEffect, useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import { fetchTestEngineerKPIMetrics } from "../../../API_Service/Dashboard_Slice";
import { companyID, KPICard, InlineAlert } from "../../../Common/UIComponents";
import { useDashboardSignalR } from "../../../Common/useDashboardSignalR";

const TestEngineerKPICards = () => {
  const dispatch = useDispatch();
  const [stats, setStats] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const employeeID = Number(localStorage.getItem("empid")) || 0;

  const loadStats = useCallback(() => {
    console.log("🔍 TestEngineerKPICards - companyID:", companyID, "employeeID:", employeeID);
    if (!companyID || !employeeID) {
      console.warn("⚠️ TestEngineerKPICards - Missing companyID or employeeID");
      setError("Missing required parameters");
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    dispatch(fetchTestEngineerKPIMetrics({ companyID, employeeID }))
      .then((result) => {
        if (result.payload && result.payload.length > 0) {
          setStats(result.payload[0]);
          setError(null);
        } else if (result.payload && !Array.isArray(result.payload)) {
          setStats(result.payload);
        }
      })
      .catch((err) => {
        setError(err?.message || "Failed to load Test Engineer KPI cards");
      })
      .finally(() => setIsLoading(false));
  }, [dispatch]);

  useEffect(() => { loadStats(); }, [loadStats]);

  useDashboardSignalR(loadStats);

  const cards = stats
    ? [
        {
          icon: "schedule",
          label: "Today's Shift",
          value: stats.TodaysShift,
          iconColor: "text-blue-600",
          gradientFrom: "from-blue-500",
          gradientTo: "to-blue-600",
        },
        {
          icon: "location_on",
          label: "Mapped Labs",
          value: stats.MappedLabs,
          iconColor: "text-green-600",
          gradientFrom: "from-green-500",
          gradientTo: "to-emerald-600",
        },
        {
          icon: "timer",
          label: "Hours Logged",
          value: `${(stats.HoursLogged || 0).toFixed(2)}h`,
          iconColor: "text-purple-600",
          gradientFrom: "from-purple-500",
          gradientTo: "to-purple-600",
        },
      ]
    : [];

  if (error) {
    return <InlineAlert type="error" message={`Error loading Test Engineer KPI cards: ${error}`} />;
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      {cards.map((card, index) => (
        <KPICard
          key={index}
          icon={card.icon}
          label={card.label}
          value={card.value}
          iconColor={card.iconColor}
          gradientFrom={card.gradientFrom}
          gradientTo={card.gradientTo}
          isLoading={isLoading}
        />
      ))}
      {isLoading && cards.length === 0 && (
        <>
          {[1, 2, 3].map((i) => (
            <div key={i} className="relative bg-white rounded-lg border border-slate-200/80 p-4 animate-pulse">
              <div className="absolute left-0 top-0 bottom-0 w-[3px] bg-slate-200 rounded-l-lg"></div>
              <div className="flex items-start justify-between gap-3 pl-1.5">
                <div className="flex-1">
                  <div className="h-2.5 bg-slate-200 rounded w-2/3 mb-2.5"></div>
                  <div className="h-7 bg-slate-200 rounded w-1/2"></div>
                </div>
                <div className="w-9 h-9 bg-slate-200 rounded-md"></div>
              </div>
            </div>
          ))}
        </>
      )}
    </div>
  );
};

export default TestEngineerKPICards;
